module.exports = __webpack_public_path__ + "media/tile-6-image.b247168a.jpg";